/**
 * Copyright (c) Matthieu POIGNANT
 * matthieu@highlight.pro
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 */
import Interface from '../../interface';
import Theme from "../../Theme";

const AboutStyled = Interface.styled('div')`
  transform: perspective( 2000px ) rotateY( 180deg );
  transition: all .3s linear;
  position: absolute;
  backface-visibility: hidden;
  width: 100%;
  height: 100%;
  z-index: -1;
`;
AboutStyled.defaultProps = {
    theme: Theme,
};

const AboutInnerStyled = Interface.styled('div')`
  width: 100%;
  height: 100%;
  background: ${(props) => props?.theme?.palette?.background ?? '#ffffff'};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  font-weight: bold;
  border-radius: 12px;
  
  & > .ziiircom-messenger-about-credits {
    font-size: 0.5em;
  }
  
  @media only screen and (max-width: 772px) {
    .ziiircom-messenger-about-inner {
      border-radius: 0 !important;
    }
  }
`;
AboutInnerStyled.defaultProps = {
    theme: Theme,
};

const AboutReturnButton = Interface.styled('button')`
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 16px;
  color: ${(props) => props?.theme?.palette?.disabledText ?? '#eeeeee'};
  background: transparent;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='${(props) => encodeURIComponent(props?.theme?.palette?.disabledText ?? '#eeeeee')}' width='512' height='512' viewBox='0 0 512 512'%3E%3Cg%3E%3Cg%3E%3Cpath d='M317.959,115.859H210.158V58.365h-44.864L0,223.66l165.294,165.294h44.864V331.46h136.548 c67.367,0,122.174,54.807,122.174,122.174H512V309.9C512,202.905,424.953,115.859,317.959,115.859z M468.88,342.412 c-30.253-33.206-73.82-54.071-122.174-54.071H167.038v41.378L60.981,223.661l106.057-106.057v41.375h150.921 c83.219,0,150.921,67.703,150.921,150.921V342.412z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-repeat:no-repeat;
  background-size: 16px;
  background-position:left;
  padding-left: 24px;
  margin-top: 8px;
`;

AboutReturnButton.defaultProps = {
    theme: Theme,
};

const e = Interface.createElement;

const About = ({handlePrevClick, handleAboutClose, aboutConfig}) =>
    e(AboutStyled, {
        className: `ziiircom-messenger-about`,
        onClick: handlePrevClick,
    }, e(AboutInnerStyled, {
        className: `ziiircom-messenger-about-inner`,
    }, `v${aboutConfig?.version}`, e('div', {
        className: `ziiircom-messenger-about-credits`,
        dangerouslySetInnerHTML: {__html: aboutConfig.credits ?? ''}
    }), e(AboutReturnButton, {
        className: `ziiircom-messenger-about-return`,
        onClick: handleAboutClose
    }, aboutConfig?.returnButton?.text ?? 'Close')));

export default About;
